import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../../types';

const defaultData: IDataLayer = {
  event_name: 'add_to_favorites',
  event_category: 'ecommerce',
  event_action: 'add to favorites',
  event_value: '0',
  event_noninteraction: 'false',
  event_label: null, // '<product name> - <product ID>'
};

function trackAddToFavorites(_: string, eventData: IDataLayer = {}) {
  eventData.event_label = tealium.dataLayer.formatProductEventLabel(eventData);
  tealium.evtLink({ ...defaultData, ...eventData });
}

registerAnalyticsEventHandler('addToFavorites', trackAddToFavorites);
